// extracted by mini-css-extract-plugin
export default {"peopleNavigation":"PeopleNavigation_peopleNavigation__s072d","link":"PeopleNavigation_link__aX0Xw","disabled":"PeopleNavigation_disabled__JdDtt"};